import { TemplateContentType } from "@/types/template.types";
import { z } from "zod";

export const templateFormSchema = z.object({
  title: z
    .string()
    .min(1, "Template name is required")
    .max(80, "Template name must be less than 80 characters"),
  subject: z.string().min(1, "Subject is required"),
  content: z.string().min(1, "Content is required"),
  contentType: z.nativeEnum(TemplateContentType),
});
